@if (displayToast) {
  <div id="toast">
    <app-toast toastStyle="positive" icon="checkmark" [text]="successResponse">
    </app-toast>
  </div>
}
@if (isLoading) {
  <div id="full-page-loading--container">
    <app-loading-spinner></app-loading-spinner>
  </div>
} @else if (laboratory) {
  <div>
    <div id="title--container">
      <h4>View Lab</h4>
      <h5>{{ laboratory?.laboratoryName }}</h5>
    </div>
    <hr />
    <div id="lab--container">
      <div class="card--container">
        <div class="card">
          <div class="header">
            <div class="card-title">
              @if (currentUser.role | roleCheck: labAdminRoles) {
                Update Laboratory
              } @else {
                Laboratory details
              }
            </div>
            <div class="body1">
              @if (currentUser.role | roleCheck: labAdminRoles) {
                Update your laboratory name
              } @else {
                View your laboratory details
              }
            </div>
          </div>
          <hr class="card-divider" aria-hidden="true" />
          <div class="content">
            <div class="form--container">
              <form [formGroup]="editLabForm">
                <app-underlined-form-field
                  [parentForm]="editLabForm"
                  [field]="labNameField"
                ></app-underlined-form-field>
              </form>
              <div class="button--container">
                <app-button
                  label="Update Laboratory"
                  buttonId="update-btn"
                  (buttonClicked)="onSubmit()"
                  [isDisabled]="
                    editLabForm.invalid ||
                    editLabForm.pristine ||
                    (currentUser.role === Role.Super_User &&
                      !laboratory.isOwnLab) ||
                    !(currentUser.role | roleCheck: labAdminRoles)
                  "
                  [isProcessing]="isUpdateLabProcessing"
                >
                </app-button>
              </div>
            </div>
          </div>
        </div>
        @if (currentUser.role | roleCheck: labAdminRoles) {
          <div class="card">
            <div class="header">
              <div class="card-title">Add Member</div>
              <div class="body1">Add a user to this laboratory</div>
            </div>
            <hr class="card-divider" aria-hidden="true" />
            <div class="content">
              @if (availableUsers?.length > 0) {
                <div class="form--container">
                  <form [formGroup]="addUserForm" id="field-with-tooltip">
                    <app-underlined-dropdown-form-field
                      [field]="addUserField"
                      [parentForm]="addUserForm"
                      [isDataList]="true"
                      tooltipText="
                      Select a user that is a member of the organisation to add to the laboratory.  If the user is not a member of the organisation, please add them to the organisation first."
                    ></app-underlined-dropdown-form-field>
                  </form>
                  @if (addUserError?.message) {
                    <span class="error">
                      {{ addUserError.message }}
                    </span>
                  }
                  <div class="button--container">
                    <app-button
                      label="Add User"
                      buttonId="add-btn"
                      (buttonClicked)="addUserToLab()"
                      [isDisabled]="addUserForm.pristine || addUserForm.invalid"
                      [isProcessing]="isAddUserToLabProcessing"
                    >
                    </app-button>
                  </div>
                </div>
              } @else if (labMemembersDropdownLoading || availableUsers === null) {
                <div class="subtitle1">
                  <app-small-loading-spinner></app-small-loading-spinner>
                </div>
              } @else {
                <div>
                  <span>No available users to add to the laboratory.</span>
                  <div class="tooltip" role="tooltip">
                    <mat-icon>info</mat-icon>
                    <div class="top">
                      In order to add a user to a laboratory, please add them to
                      the organisation first.
                      <i></i>
                    </div>
                    <div class="tooltip-accessibility">
                      In order to add a user to a laboratory, please add them to
                      the organisation first.
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
      <div class="members-table-card">
        <div class="header">
          <div class="card-title">Laboratory members</div>
          <div class="body1">Users assigned to this laboratory</div>
        </div>
        <hr class="card-divider" aria-hidden="true" />
        <div class="content--container">
          @if (
            (!users || users?.length === 0) && !labMembersTableLoading && !isLoading
          ) {
            <div id="inner-page--container">
              <p id="no-users">Laboratory does not have any members.</p>
            </div>
          }
          @if ((!users || users?.length === 0) && labMembersTableLoading) {
            <div id="loading--container">
              <app-loading-spinner></app-loading-spinner>
            </div>
          }
          @if (users?.length > 0) {
            <div id="inner-page--container">
              <p id="table-description" style="display: none">User table</p>
              <div id="table--container">
                <table aria-describedby="table-description">
                  <thead>
                    <tr>
                      <th
                        id="first-name"
                        scope="col"
                        (click)="onSort('FirstName')"
                        [class.active]="currentSort.sortBy === 'FirstName'"
                      >
                        <div id="table-header">
                          <span>First Name</span>
                          <mat-icon
                            aria-label="sort direction"
                            matTooltip="Sort direction"
                            >swap_vert</mat-icon
                          >
                        </div>
                      </th>
                      <th
                        id="last-name"
                        scope="col"
                        (click)="onSort('LastName')"
                        [class.active]="currentSort.sortBy === 'LastName'"
                      >
                        <div id="table-header">
                          <span>Last Name</span>
                          <mat-icon
                            aria-label="sort direction"
                            matTooltip="Sort direction"
                            >swap_vert</mat-icon
                          >
                        </div>
                      </th>
                      <th
                        id="email"
                        scope="col"
                        (click)="onSort('UserEmail')"
                        [class.active]="currentSort.sortBy === 'UserEmail'"
                      >
                        <div id="table-header">
                          <span>Email</span>
                          <mat-icon
                            aria-label="sort direction"
                            matTooltip="Sort direction"
                            >swap_vert</mat-icon
                          >
                        </div>
                      </th>
                      <th id="status" scope="col">
                        <div id="table-header">
                          <span>Status</span>
                        </div>
                      </th>
                      <th
                        id="role"
                        scope="col"
                        (click)="onSort('Role')"
                        [class.active]="currentSort.sortBy === 'Role'"
                      >
                        <div id="table-header">
                          <span>Role</span>
                          <mat-icon
                            aria-label="sort direction"
                            matTooltip="Sort direction"
                            >swap_vert</mat-icon
                          >
                        </div>
                      </th>
                      <th id="actions" scope="col">
                        <div id="table-header">
                          <span>Actions</span>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (user of users; track user.id) {
                      <tr
                        (click)="canEditUser(user) && onEditUser(user.id)"
                        [class.clickable-row]="canEditUser(user)"
                      >
                        <td>{{ user.firstName }}</td>
                        <td>{{ user.lastName }}</td>
                        <td>{{ user.email }}</td>
                        <td class="status-cell">
                          @if (user.userStatus != null) {
                            <app-status-indicator
                              [status]="UserStatusPrimaryDisplay[user.userStatus]"
                            ></app-status-indicator>
                          }
                          @if (user.isLockedOut) {
                            <span
                              class="status-secondary status-secondary--expired"
                              >Account locked</span
                            >
                          }
                          @if (user.isDisabled) {
                            <span
                              class="status-secondary status-secondary--expired"
                              >Account disabled</span
                            >
                          }
                          @if (user.twoFactorEnabled) {
                            <span
                              class="status-secondary status-secondary--two-factor"
                              >2FA enabled</span
                            >
                          }
                        </td>
                        <td (click)="$event.stopPropagation()">
                          @if (hideUserRoleDropdown(user)) {
                            {{ user.role | formatRole }}
                          } @else {
                            <div id="update-role">
                              {{ user.role | formatRole }}
                              @if (
                                !user.isMemberOfMultipleLabGroups &&
                                user.userStatus === UserStatus.Active
                              ) {
                                <form
                                  [formGroup]="editUserForm"
                                  id="update-role-form"
                                >
                                  <app-underlined-dropdown-form-field
                                    [field]="userRoleField"
                                    [parentForm]="editUserForm"
                                  ></app-underlined-dropdown-form-field>
                                  <app-button
                                    label="Update"
                                    buttonId="edit-btn"
                                    (buttonClicked)="onUpdateUser(user.id)"
                                    [isProcessing]="
                                      isUpdateRoleProcessing &&
                                      updateUserId === user.id
                                    "
                                    [isDisabled]="
                                      !(
                                        currentUser.role | roleCheck: labAdminRoles
                                      ) || user.userStatus !== UserStatus.Active
                                    "
                                  >
                                  </app-button>
                                </form>
                              }
                            </div>
                          }
                        </td>
                        <td
                          id="button--container"
                          (click)="$event.stopPropagation()"
                        >
                          @if (user.userStatus === UserStatus.Active) {
                            <app-mat-icon-button
                              buttonId="edit-btn"
                              iconName="edit"
                              ariaLabel="Edit User"
                              (buttonClicked)="onEditUser(user.id)"
                              [isDisabled]="!canEditUser(user)"
                            ></app-mat-icon-button>
                            <app-mat-icon-button
                              buttonStyle="negative"
                              buttonId="remove-btn"
                              ariaLabel="Remove From Lab"
                              iconName="delete"
                              (buttonClicked)="handleRemoveUserFromLab(user.id)"
                              [isDisabled]="
                                !(currentUser.role | roleCheck: labAdminRoles) ||
                                user.userStatus !== UserStatus.Active
                              "
                            ></app-mat-icon-button>
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
                <div id="pagination--container">
                  <div class="filter--container">
                    <label for="approvals-action">Filter by role</label>
                    <app-dropdown-form-field
                      id="action-filter"
                      [field]="userRolesFilter"
                      [parentForm]="usersTableControls"
                    >
                    </app-dropdown-form-field>
                  </div>
                  <div class="filter--container">
                    <label for="users-per-page">Users per page</label>
                    <app-dropdown-form-field
                      id="users-per-page"
                      [field]="usersPerPageField"
                      [parentForm]="usersTableControls"
                    >
                    </app-dropdown-form-field>
                  </div>
                  <div id="pagination--controls">
                    <app-icon-button
                      iconName="chevron_left"
                      buttonId="previous"
                      (buttonClicked)="getPrevious()"
                      [isDisabled]="!hasPrevious"
                    ></app-icon-button>
                    <span> {{ currentPage }} / {{ totalPages }} </span>
                    <app-icon-button
                      iconName="chevron_right"
                      buttonId="next"
                      (buttonClicked)="getNext()"
                      [isDisabled]="!hasNext"
                    ></app-icon-button>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      @if (currentUser.role | roleCheck: ogiSuperAdminOnly) {
        <div class="action-card--container">
          <app-button-card
            cardStyle="negative"
            title="Delete laboratory"
            bodyLine1="Removes this laboratory and its associated data."
            bodyLine2="Please ensure you wish to proceed before continuing."
            buttonLabel="Delete laboratory"
            buttonId="delete-lab-btn"
            iconName="delete"
            (buttonClicked)="openModal('delete-lab')"
          ></app-button-card>
        </div>
      }
    </div>
  </div>
} @else {
  <app-error-page
    title="You are not a member of this lab"
    primaryText="Sorry, you cannot access this page unless you are a member of a lab"
  ></app-error-page>
}
<app-modal
  id="error"
  titleText="Error"
  [primaryText]="error?.message"
  primaryButtonText="close"
  primaryButtonId="close-button"
  modalStyle="error"
  (modalButtonClicked)="closeModal('error')"
></app-modal>
<app-modal
  id="attention"
  titleText="Attention"
  primaryText="Your changes have not been saved. Press cancel to return to the form and save your changes, or continue to discard."
  buttonLayout="double-button"
  primaryButtonText="Continue"
  primaryButtonId="confirm-navigation"
  secondaryButtonText="Cancel"
  secondaryButtonId="cancel-button"
  modalStyle="warning"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-validation-modal
  id="delete-lab"
  titleText="Delete laboratory"
  validationText="delete"
  primaryButtonText="Confirm delete"
  primaryButtonId="primary-button"
  secondaryButtonText="Close"
  secondaryButtonId="secondary-button"
  (modalButtonClicked)="deleteLab()"
  [error]="error"
></app-validation-modal>
<app-validation-modal
  id="remove-user"
  titleText="Remove user from laboratory"
  validationText="remove"
  primaryButtonText="Confirm"
  primaryButtonId="confirm-remove-button"
  (modalButtonClicked)="onRemoveUserFromLab()"
  secondaryButtonText="Cancel"
  secondaryButtonId="cancel-remove-button"
  [isProcessing]="isRemoveUserFromLabProcessing"
  [error]="error"
></app-validation-modal>
